import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "style", "children"]; /// <reference types="@uiw/react-baidu-map-types" />

import React, { useRef, useEffect, useImperativeHandle, useReducer, useMemo } from 'react';
import { useMap } from './useMap';
import { Context, reducer, initialState } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export * from './useMap';
export * from './context';
export var Provider = function Provider(props) {
  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return /*#__PURE__*/_jsx(Context.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    },
    children: props.children
  });
};
export default /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useReducer3 = useReducer(reducer, initialState),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      state = _useReducer4[0],
      dispatch = _useReducer4[1];

  window.BMap = window.BMap || window.BMapGL;
  var elmRef = useRef(null);

  var _useMap = useMap(_extends({
    container: elmRef.current
  }, props)),
      setContainer = _useMap.setContainer,
      container = _useMap.container,
      setCenter = _useMap.setCenter,
      setAutoLocalCity = _useMap.setAutoLocalCity,
      map = _useMap.map; // eslint-disable-next-line react-hooks/exhaustive-deps


  useEffect(function () {
    return setContainer(elmRef.current);
  }, [elmRef.current]); // eslint-disable-next-line react-hooks/exhaustive-deps

  useMemo(function () {
    return props.center && setCenter(props.center);
  }, [props.center]); // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(function () {
    return setAutoLocalCity(props.autoLocalCity);
  }, [props.autoLocalCity]); // eslint-disable-next-line react-hooks/exhaustive-deps

  useImperativeHandle(ref, function () {
    return _extends({}, props, {
      map: map,
      BMap: BMap,
      container: elmRef.current
    });
  }, [map]);
  var childs = React.Children.toArray(children);
  useEffect(function () {
    if (map) {
      dispatch({
        map: map,
        container: elmRef.current,
        BMap: BMap
      });
    }
  }, [map]);
  return /*#__PURE__*/_jsxs(Context.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    },
    children: [/*#__PURE__*/_jsx("div", {
      ref: elmRef,
      className: className,
      style: _extends({
        fontSize: 1,
        height: '100%'
      }, style)
    }), BMap && map && typeof children === 'function' && children({
      BMap: BMap,
      map: map,
      container: container
    }), BMap && map && childs.map(function (child, key) {
      if (! /*#__PURE__*/React.isValidElement(child)) return null;

      if (child.type && typeof child.type === 'string') {
        return /*#__PURE__*/React.cloneElement(child, {
          key: key
        });
      }

      return /*#__PURE__*/React.cloneElement(child, _extends({}, child.props, {
        BMap: BMap,
        map: map,
        container: container,
        key: key
      }));
    })]
  });
});